// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"7647909d","899":"dbb3311b"}[chunkId] + ".chunk.css";
};